import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'TrustNameSearch',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                trust_name: ''
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        submit_trust_name() {
            if (!this.form.trust_name.trim()) {
                this.showError('Error', 'Trust Name is required');
                return false;
            }
            this.trust_name_search_api();
        },
        trust_name_search_api() {
            const TOKEN = localStorage.getItem('token');
            const TRUST_NAME_SEARCH_API = `${API_BASE_URL}/verify_api/instant_verify_api/trust_name_search/`;

            $.ajax({
                url: TRUST_NAME_SEARCH_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    trust_name: this.form.trust_name
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Trust Name Found Successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.trust_name = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
